import { Injectable } from '@angular/core';
import { CanActivate, Router,
         ActivatedRouteSnapshot,
         RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService, AuthUser } from './auth.service';
import { AppConstants, LOGON_INFO } from '../app.constants';


@Injectable()
export class AuthGuard implements CanActivate {

    //private userSubject = new BehaviorSubject<AuthUser>(new AuthUser());

    constructor (
        private authService: AuthService,
        private router: Router
    ) {  }
    
    async canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot): Promise<boolean> {

        //const authUser: AuthUser = await this.checkAsync();

        if (this.authService.isAuthenticated()) {
            //メニューへのアクセス権限チェック
            if (route.data.role && route.data.role.indexOf(LOGON_INFO.MENU_ROLE) === -1) {
                this.router.navigate(['/notice-show']);
                return false;
            }
            
            this.authService.jwtRefreshCheck();
            return true;
        }

        // Store the attempted URL for redirecting
        this.authService.redirectUrl = state.url;

        //ログインしていない場合、ログイン画面に飛ばす
        this.router.navigate(['/login']);

        return false;
    }



    /**
     * ログイン状態を確認する
     * ログイン状態ならログイン情報が取得でき、未ログインの場合は空のオブジェクトが渡される
    async checkAsync() {
        var authUser: AuthUser = null;
        await this.authService.isAuthenticated()
        .then(
            data => authUser = data
        ).catch(
            e => authUser = null
        );

        this.userSubject.next(authUser);

        return authUser;
    }
    */


    /**
     * ログイン情報をリアルタイムに通知する
     * 未ログインであれば空のオブジェクトが、
     * ログイン済みであればログイン情報がストリームに流れる
    getUserInfo(): Observable<AuthUser> {
        return this.userSubject;
    }
    */
    
}






// WEBPACK FOOTER //
// ./src/app/login/auth-guard.service.ts